module.exports = __webpack_public_path__ + "static/media/falcon.4b970315.png";